import { CommonModule } from '@angular/common';
import { Component, inject} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from '../../../components/layout/loader/loader.component';
import { StudyFormComponent } from '../../../components/study/study-form/study-form.component';
import { TableGuruComponent } from '../../../components/table-guru/table-guru.component';

@Component({
  selector: 'app-studies-index',
  standalone: true,
  imports: [
    CommonModule,
    StudyFormComponent,
    LoaderComponent,
    TableGuruComponent
  ],
  templateUrl: './studies-index.component.html',
  styleUrl: './studies-index.component.scss'
})
export class StudiesIndexComponent {
  items : []  = [];
	private modalService = inject(NgbModal);
  reloadItems: boolean = false;

  editFormReference = StudyFormComponent;

  constructor () {}  

	openModal(item: any) {    
    let self = this;
		const modalRef = this.modalService.open(StudyFormComponent);
		modalRef.componentInstance.modalStyle = true;
		modalRef.componentInstance.item = item;
		modalRef.result.then((result) => {
      self.reloadItems = true;

      setTimeout(() => {
        self.reloadItems = false;
      }, 200);
    });
	}
}
